import { render } from "./RegionSetting.vue?vue&type=template&id=0b72932f&scoped=true"
import script from "./RegionSetting.vue?vue&type=script&lang=js"
export * from "./RegionSetting.vue?vue&type=script&lang=js"

import "./RegionSetting.vue?vue&type=style&index=0&id=0b72932f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b72932f"]])

export default __exports__